import React, { Component } from "react";
import { formatDate, parseDate } from "react-day-picker/moment";
import moment from "moment";
import "react-day-picker/lib/style.css";
import DayPickerInput from "react-day-picker/DayPickerInput";
import { CSVWrapper, DateSelect } from "./ExportCSV.styled";
import TitleWrapper from "../../components/TitleWrap/TitleWrap";
import { Button, message, Select } from "antd";
import {
  CustomField,
  MakerWrapper,
  OrderWrapper,
} from "../MarkOrder/MarkOrder.style";
import UserGreeting from "../../components/UserGreeting/UserGreeting";
import { CircularProgress } from "@material-ui/core";
import { GrDocumentCsv } from "react-icons/gr";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { fetchPickerReport } from "../../redux/PickerCheckerHourly/actions";
import { warehouseId } from "../../constants";

class ExportCSV extends Component {
  state = {
    from: undefined,
    to: undefined,
    loaderSearch: false,
    statLocal: null,
    // selectedTags: ["All"],
    loading: false,
    pickerStat: null,
    csvBlock: true,
    currentBox: null,
    toggleClick: false,
    fromTime: undefined,
    fromTimeString: null,
    toTimeString: null,
    toTime: undefined,
    openTimePicker: false,
    disableToTime: true,
    hourlyReport: null,
    role: null,
    options: [
      {
        value: "picker",
        label: "Picker",
      },
      {
        value: "checker",
        label: "Checker",
      },
    ],
  };
  DateFormatter = (param) => {
    let result =
      this.state[param].getFullYear() +
      "-" +
      (this.state[param].getMonth() + 1) +
      "-" +
      this.state[param].getDate();
    return result;
  };
  exportCsvFunc = () => {
    this.setState({ loading: true });
    message.loading("Loading, please wait...", 0);
    let fromRefined = this.DateFormatter("from");
    let toRefined = this.DateFormatter("to");

    const vals = {
      access_token: this.props.access_token,
      warehouseId: warehouseId,
      fromDate: this.state.fromTimeString
        ? fromRefined + " " + this.state.fromTimeString + ":00:00"
        : fromRefined + " 00:00:01",
      toDate: this.state.toTimeString
        ? toRefined + " " + this.state.toTimeString + ":59:59"
        : toRefined + " 23:59:59",
      isPicker: this.state.role === "picker" ? true : false,
    };
    this.props.fetchPickerReport(vals).then(() => {
      message.destroy();
      if (this.props.pickerCheckerReportReducer.pickerReportError) {
        message.error(
          this.props.pickerCheckerReportReducer.pickerReportError,
          2
        );
        this.setState({
          loading: false,
        });
      } else if (this.props.pickerCheckerReportReducer?.pickerReportSuccess) {
        this.setState(
          {
            hourlyReport: this.props.pickerCheckerReportReducer
              ?.pickerReportSuccess,
          },
          () => {
            window.open(`${this.state.hourlyReport}`, "_blank");
            this.setState({
              loading: false,
            });
          }
        );
        this.setState({
          loading: false,
        });
      }
    });
  };
  handleFromChange = (from) => {
    this.setState({ from });
  };
  handleToChange = (to) => {
    this.setState({ to }, this.showFromMonth);
  };
  showFromMonth = () => {
    const { from, to } = this.state;
    if (!from) {
      return;
    }
    if (moment(to).diff(moment(from), "months") < 2) {
      this.to.getDayPicker().showMonth(from);
    }
  };
  render() {
    const { from, to, role, loading } = this.state;
    const modifiers = { start: from, end: to };

    return (
      <div className="centerScreen">
        <MakerWrapper>
          <UserGreeting />
          <div style={{ marginTop: "25px" }}>
            <TitleWrapper title={"Picker & Checker Hourly Reports"} />

            <div className="inputWrap">
              <OrderWrapper style={{ flexDirection: "column" }}>
                <DateSelect>
                  <DayPickerInput
                    value={from}
                    placeholder="Select From Date"
                    format="DD/MM/YYYY"
                    formatDate={formatDate}
                    parseDate={parseDate}
                    dayPickerProps={{
                      selectedDays: [from, { from, to }],
                      disabledDays: { after: to },
                      toMonth: to,
                      modifiers,
                      numberOfMonths: 2,
                      onDayClick: () => this.to.getInput().focus(),
                    }}
                    onDayChange={this.handleFromChange}
                  />

                  <DayPickerInput
                    ref={(el) => (this.to = el)}
                    value={to}
                    placeholder="Select To Date"
                    format="DD/MM/YYYY"
                    formatDate={formatDate}
                    parseDate={parseDate}
                    dayPickerProps={{
                      selectedDays: [from, { from, to }],
                      disabledDays: { before: from },
                      modifiers,
                      month: from,
                      fromMonth: from,
                      numberOfMonths: 2,
                    }}
                    onDayChange={this.handleToChange}
                  />
                </DateSelect>
                <div className="inputWrap">
                  {/* Select if it's a Picker or a checker */}
                  <Select
                    // defaultValue={this.state.options[0]}
                    placeholder="Select a Role"
                    name="option"
                    style={{ width: "100%" }}
                    autoFocus
                    variant="outlined"
                    options={this.state.options}
                    onChange={(e) => {
                      this.setState({
                        role: e,
                      });
                    }}
                  />
                </div>
                <button
                  className="bbtn"
                  style={{ width: "max-content" }}
                  disabled={!from || !to || !role || loading}
                  onClick={this.exportCsvFunc}
                >
                  Export CSV <GrDocumentCsv />
                </button>
              </OrderWrapper>
              <br />
            </div>
          </div>
        </MakerWrapper>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  pickerCheckerReportReducer: state.pickerCheckerReportReducer,
});
const mapDispatchToProps = {
  fetchPickerReport,
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ExportCSV)
);
